import { Validator } from '../Validator';

export default class ExistValueService implements Validator {

  // tslint:disable-next-line no-any
  public getValidation(value: any,  message: string = 'undefined message'): Promise<void> {
    return new Promise(
      (res, error) => {
        if (value === undefined || value === null || value === '') {
          error(message);
        } else {
          res();
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/services/validation/validators/ExistValue.tsx